module.exports = __webpack_public_path__ + "static/media/baker-steel-gold.4478a7d3.csv";